import React from 'react'
import {CardMedia as RmwcCardMedia} from '@rmwc/card'
import '@rmwc/card/styles'

const CardMedia = (props) => <RmwcCardMedia {...props} />

export {CardMedia}
